module.exports = __webpack_public_path__ + "img/bg.7b156d7b.png";